import { StyleSheet, Text, View } from "react-native";
import { FONT } from "../../../value/staticValues";

interface ProgressBarProps {
    color: string;
    total?: string | number;
    percent: number;
}

export default function ProgressBar(props:ProgressBarProps) {
    return (
        <View>
            <View style={{flexDirection: "row", alignItems: "center"}}>
                <Text style={{
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: props.color
                }}>
                    {props.percent} %
                </Text>
                <Text style={{
                    marginLeft: "auto",
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#333"
                }}>
                    {props.total ? props.total : "Max"}
                </Text>
            </View>
            <View style={{
                ...styles.BarStyle,
            }}/>
            <View style={{
                ...styles.BarStyle,
                marginTop: -10,
                width: props.percent + "%",
                backgroundColor: props.color,
            }}/>
        </View>
    )
}

const styles = StyleSheet.create({
    BarStyle: {
        width: "100%", height: 10,
        borderRadius: 5,
        backgroundColor: "#f5f5f5",

    }
})